export default __webpack_public_path__ + "static/media/noIcon.6101b65d.svg";